<div class="component-wrapper">
  <p-table
      (onLazyLoad)="load($event)"
      [lazy]="true"
      [lazyLoadOnInit]="false"
      [loading]="isLoading"
      [paginator]="true"
      [resizableColumns]="true"
      [rowHover]="true"
      [rows]="rows"
      [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
      [scrollable]="true"
      [showCurrentPageReport]="true"
      [sortOrder]="sortOrder"
      [sortField]="sortField"
      [totalRecords]="totalRecords"
      [value]="records"
      columnResizeMode="fit"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      groupRowsBy="name"
      responsiveLayout="scroll"
      scrollHeight="calc(100vh - 255px)"
      sortMode="single">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th class="col-filename" pSortableColumn="filename">
          Filename <p-sortIcon field="filename"></p-sortIcon>
        </th>
        <th class="col-sent_by" pSortableColumn="sent_by">
          Uploaded By <p-sortIcon field="sent_by"></p-sortIcon>
        </th>
        <th class="col-where">
          Where
        </th>
        <th class="col-upload_date" pSortableColumn="upload_date">
          Date <p-sortIcon field="upload_date"></p-sortIcon>
        </th>
        <th class="col-actions">
          Folder
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
      <tr class="record-row" (click)="preview(record.etag)">
        <td class="col-filename">
          {{ record.filename }}
        </td>
        <td class="col-sent_by">
          {{ record.sent_by.full_name }}
        </td>
        <td class="col-where">
          @if (record.tracked_item) {
            Client Task
          }
          @else if (record.from_conversation) {
            Message
          }
          @else if (record.from_easy_upload) {
            Easy Upload
          }
          @else {
            File Manager
          }
        </td>
        <td class="col-upload_date">
          {{ record.upload_date | amFromUtc | amLocal | amCalendar : moment_calendar_format }}
        </td>
        <td>
          <div class="col-actions">
            @if (record.folder_uuid) {
              {{ record.folder.name }}
            }
            @else {
              @if (record.staff_only && !record.shared) {
                Internal Folders
              }
              @else if (!record.staff_only && record.shared) {
                Client Shared Folder
              }
              @else {
                <!-- if accountant -->
                 @if(userData.user_type == 1) {
                   <a (click)="move($event, record)">Add to Folder</a>
                 }
              }
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>